// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { IconComponent } from '@lbca-shared/icon';
import { MessageFeedTemplate } from 'models/shared.models';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ASSETS } from '../../../../../assets/assets';
import { waitingTimer } from '../../../../../helpers/_old_helpers/animate';
import { USER_SERVICE, UserServiceInterface } from '../../../../../services/user.services';
import { BodyFeedbackComponent } from '../../../body-feedback/body-feedback.component';
import { InputBooleanComponent } from '../../../fields/input-boolean/input-boolean.component';
import { InputTextComponent } from '../../../fields/input-text/input-text.component';
import { SelectTreeService } from '../../../fields/select-tree/select-tree.service';
import { ModalDirective, ModalInterfaceComunication } from '../../../modal-overlay/modal.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../popup-feedback/popup-feedback.directive';
import { TableSecondaryComponent } from '../../../table-secondary/table-secondary.component';
import { FormTemplateService } from '../form-template/form-template.service';
import { ClaimEditLegalRequestComponent } from './claim-edit-legal-request/claim-edit-legal-request.component';
import { ClaimNewLegalRequestComponent } from './claim-new-legal-request/claim-new-legal-request.component';
import { ClaimPhaseComponent } from './claim-phase/claim-phase.component';
import { field, fieldListPrimary } from './claim.fields';
import { ClaimService } from './claim.service';
import { getField } from './helpers/data-values';

@Component({
  selector: 'lbca-sub-module-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss', '../sub-form/subform.component.scss'],
  imports: [
    InputBooleanComponent,
    InputTextComponent,
    NgClass,
    BodyFeedbackComponent,
    TableSecondaryComponent,
    ClaimPhaseComponent,
    ClaimNewLegalRequestComponent,
    ClaimEditLegalRequestComponent,
    IconComponent,
  ],
})
export class ClaimComponent implements OnInit, OnDestroy {
  readonly assets = inject(ASSETS);
  private overlay = inject(Overlay);
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;
  @ViewChild('templateMessage') templateMessage!: TemplateRef<any>;

  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController,
  );

  public userId!: string;
  public taskId!: string;
  public processId!: string;
  public currentLegalRequest;
  public removeSteps: any = [];
  public generalDataNoPhase = {};

  public line;
  public lineremove;

  @ViewChild('actionsEditRender', { static: true })
  actionsEditRender!: ElementRef;

  @ViewChild('actionsExcluirRender', { static: true })
  actionsExcluirRender!: ElementRef;

  public claimLabelsDict: object = {};

  private modalController = new ModalInterfaceComunication();

  lbcaModal = new ModalDirective(
    this.overlay,
    this.modalController,
  );

  @ViewChild('ModalTemplate') templateModal!: TemplateRef<any>;
  @ViewChild('ModalRegisterTemplate') registerModal!: TemplateRef<any>;
  @ViewChild('ModalEdit') editModal!: TemplateRef<any>;

  public paginationType: 'prev' | 'next' = 'prev';

  public transition: 'entrada' | 'saida' = 'entrada';

  public totalPedidos;
  public currenPhase;
  public firstLoadControl = false;
  public showOtherPhases = false;
  public loadPage = false;
  public isRemovable = true;
  public isEditable = true;

  public contentTypeText = false;
  public history = false;
  public hasHistory = false;

  public getFieldv: any = getField();

  public properties;
  public registerPhase;

  public flowId;
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }

  public dataAttr;
  @Input('dataAttr') set data(data) {
    this.dataAttr = data;
    this.processId = this.dataAttr.processNumber;
  }

  @Input() disabled = true;

  @Input('properties')
  set modulesData(prop) {
    this.properties = prop;
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  public field: any = field;
  public valoresRestore: any;
  public pedidoEdit: any = [];

  private linkedUsers: any = [];
  public steps: any = [];
  public stepsRender: any = [];
  public claimList: any = [];
  public tableDataClaim: any = [];
  public dataClaim: any = [];
  public mainDataFields: any = [];
  public colsMainClaim: any = [];
  public colsSecMainClaim: any = [];
  public fieldListNewClaim;
  public editPhase;

  public feedtext = 'Empty';
  public emojis = 'emoji--glasses icon-box ml-[16px]';

  public messageFeedObject: MessageFeedTemplate = {
    primary: '',
    secondary: '',
    emoji: '',
    type: 'danger',
    show: false,
    autoclose: true,
  };

  public closeFeed(): void {
    this.messageFeedObject.show = false;
  }
  public hasCapability: any = true;

  popSubscription!: Subscription;
  routerSubscription!: Subscription;
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private claimService: ClaimService,
    public elementRef: ElementRef,
    public selectTreeService: SelectTreeService,
    private dynamicFormService: FormTemplateService,
  ) {}

  ngOnInit() {
    this.claimLabelsDict = this.assets.labels.components.claim;
    this.popSubscription = this.claimService.showPopupFeedController.subscribe((data: any[]) => {
      this.showTemplateMessage(data);
    });

    const { params } = this.route.snapshot;
    const regexBase = new RegExp('/base/');
    const regexTask = new RegExp('/task/');
    if (regexTask.test(this.router.url)) {
      this.taskId = params['id'];
    } else if (regexBase.test(this.router.url)) {
      this.taskId = 'base';
    } else {
      this.taskId = 'createCase';
    }
    this.mainData();
    this.loadPage = false;
    this.preparaTableByClaim().then(() => {
      this.loadData();
    });
    if (
      this.properties.capabilityName &&
      this.properties.capabilityName === 'legalRequestBaseEdit'
    ) {
      this.hasCapability = this.userService.hasCapability(this.properties.capabilityName);
    }

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((val) => this.modalController.closeModal());
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.popSubscription?.unsubscribe();
  }

  private async setUsers() {
    const FindUsers: string[] = [];
    this.steps.forEach((fase) => {
      if (fase.legalRequests)
        fase.legalRequests.forEach((pedido) => {
          if (!pedido.description) return;
          const id = pedido.updateBy ? [pedido.updateBy] : [pedido.createBy];
          const idLinked = this.linkedUsers.find((item) => item.id === id);
          if (!idLinked) {
            const idContain = FindUsers.find((item) => item === (id as any));
            if (!idContain) FindUsers.push(id as any);
          } else {
            pedido.user = idLinked.fullname;
          }
        });
    });

    this.userService.returnUserListById(FindUsers).then((listUsers) => {
      if (listUsers && listUsers.length > 0) {
        this.steps.forEach((fase) => {
          if (fase.legalRequests)
            fase.legalRequests.forEach((pedido) => {
              if (!pedido.description) return;
              const userId = pedido.updateBy || pedido.createBy;
              const user = listUsers.find((item) => item.id === userId);
              if (user) {
                pedido.user = user.fullname;
                if (!this.linkedUsers.find((item) => item.id === userId))
                  this.linkedUsers.push({
                    id: userId,
                    fullname: user.fullname,
                    userRef: pedido.updateBy ? `updateBy` : `createBy`,
                  });
              }
            });
        });
      }

      // this.steps = [...this.steps];
    });
  }

  public loadData() {
    const history = this.getFieldv['oldPhases'].value;
    if (!history) {
      console.warn('erro: history não localizado');
      return;
    }

    const taskId = this.taskId;
    const userId = this.userId;
    const processId = this.processId;
    const context = field.context;

    const params = {
      taskId,
      processId,
      userId,
      history,
      context,
    };

    if (this.properties.notHasPhase) {
      this.claimService.request<any[]>(params).subscribe(
        (resp: any[]) => {
          this.tableDataClaim['noPhase'] = {
            config: {
              highlight: () => {
                return true;
              },
            },
            columns: this.colsMainClaim,
            details: this.colsSecMainClaim,
            body: resp || [],
            loaded: true,
          };

          this.generalDataNoPhase = {
            legalRequestCount: resp.length,
            initCalculateValue: resp.reduce((acc, cur) => acc + Number(cur.primaryValue), 0),
            updateCalculateValue: resp.reduce(
              (acc, cur) => acc + Number(cur.primaryValueCorrectBalance),
              0,
            ),
            totalriskCalculate: resp.reduce((acc, cur) => acc + Number(cur.riskCalculate), 0),
          };

          this.mountValuesPhases(this.generalDataNoPhase);

          this.loadPage = true;
        },
        (err: any) => {
          return this.defautlFeedbackServerError(err);
        },
      );
    } else {
      this.claimService.getStep(params).subscribe(
        async (claim: any) => {
          if (!claim) {
            this.steps = [];
            return undefined;
          }

          if (claim.errors) {
            this.defautlFeedbackServerError(claim.errors);
            return;
          }

          const response = claim.step;
          const notRemoveLoad: { label: string; id: string; phaseId: string }[] = [];
          if (!response)
            claim.forEach((item) =>
              notRemoveLoad.push({
                label: item.label,
                id: item.id,
                phaseId: item.phaseId,
              }),
            );

          this.removeSteps = claim.removeSteps || notRemoveLoad;

          if (claim.step) claim = [claim.step];

          let expandStepId;

          if (this.pedidoEdit.length > 0) expandStepId = this.pedidoEdit[0].stepId;

          this.currentLegalRequest = claim[0];

          if (this.currentLegalRequest) {
            claim.filter((element) => {
              if (element.id === this.currentLegalRequest.id) {
                element.legalRequests = this.currentLegalRequest.legalRequests;

                if (
                  this.currentLegalRequest.phaseId &&
                  this.tableDataClaim[this.currentLegalRequest.phaseId] &&
                  element.legalRequests
                ) {
                  this.tableDataClaim[this.currentLegalRequest.phaseId].body =
                    element.legalRequests;
                  this.tableDataClaim[this.currentLegalRequest.phaseId].loaded = true;
                }
              }
            });
          }

          this.steps = claim;
          this.stepsRender = this.steps;

          this.steps.forEach((item, index) => {
            item.expandDetails = index === 0 || expandStepId === item.id ? true : false;
            this.mountValuesPhases(item);
            if (item.expandDetails && this.tableDataClaim[item.phaseId]) this.requestTable(item);
          });

          this.pedidoEdit = [];

          this.loadPage = true;
        },
        (err: any) => {
          this.defautlFeedbackServerError(err);
        },
      );
    }
  }

  public request(claim) {
    // abrir listagem de pedidos nas tabelas

    const taskId = this.taskId;
    const userId = this.userId;
    const processId = this.processId;
    const stepId = claim.id;
    const { context } = field;
    const params = {
      taskId,
      processId,
      userId,
      stepId,
      context,
    };

    return this.claimService.request(params);
  }

  private requestTable(claim) {
    if (!claim) return;

    if (this.tableDataClaim[claim.phaseId]) {
      this.tableDataClaim[claim.phaseId].body = [];
      this.tableDataClaim[claim.phaseId].loaded = false;

      this.request(claim).subscribe((resp: any) => {
        if (resp && resp.errors) {
          this.defautlFeedbackServerError(resp.errors);
          return;
        }
        if (!resp) resp = [];

        resp.forEach((item: any) => this.mountLocalRequests(item));
        claim.legalRequests = resp;

        this.setUsers();

        this.tableDataClaim[claim.phaseId].body = resp;
        this.tableDataClaim[claim.phaseId].loaded = true;
      });
    }
  }

  public async openPhaseDetails(ev: HTMLDivElement, openClose: HTMLSpanElement, claim: any) {
    if (ev.classList.contains('open')) {
      ev.classList.remove('open');
      claim.motion = 'prev';
      openClose.innerHTML = this.claimLabelsDict['open'];
    } else {
      this.requestTable(claim);

      claim.motion = 'next';
      ev.classList.add('open');
      openClose.innerHTML = this.claimLabelsDict['close'];
    }
  }

  public deleteItem($event, lane) {
    lane.deleted = !lane.deleted;
    this.line = { id: lane.id, status: lane.deleted };
  }

  private async confirmDelete(lane) {
    this.lineremove = { id: lane.id };
    lane.confirmDelete = !lane.confirmDelete;

    await waitingTimer(600);
    const phaseId = lane?.phaseId ?? 'noPhase';

    if (!phaseId) {
      this.defautlFeedbackServerError(`Erro de phaseId não encontrada`);
      return;
    }

    const steps = this.tableDataClaim[phaseId].body;

    if (steps) {
      const newBody = steps.filter((removeStep) => removeStep.id !== lane.id);
      this.tableDataClaim[phaseId].body = newBody;
    }

    const taskId = this.taskId;

    const pedidos = JSON.parse(JSON.stringify([lane]));
    pedidos.forEach((item: any) => (item.deleted = true));
    const body = pedidos[0];

    if (body.user) delete body.user;

    const bodyCopy = JSON.parse(JSON.stringify(pedidos))[0];
    this.mountLocalRequests(bodyCopy);
    const params = { id: body.id, taskId };
    const currentDate = new Date();
    const timestamp = currentDate.getTime();
    this.claimService.editClaim(body, params).subscribe(
      (resp: any) => {
        if (resp.errors) {
          this.defautlFeedbackServerError(resp.errors);
          return;
        } else {
          this.showTemplateMessage(['Pedido removido', 'emoji--glasses icon-box ml-[16px]']);
          this.loadData();
        }
      },
      (err: any) => this.defautlFeedbackServerError(err),
    );
  }

  private mountLocalRequests(item: any): void {
    item.dateReference = this.dateTreatment(item.dateReference);
    item.interestDateReference = this.dateTreatment(item.interestDateReference);
    item.primaryValue = parseFloat(item.primaryValue || 0).toFixed(2);
    item.riskCalculate = parseFloat(item.riskCalculate || 0).toFixed(2);
  }

  private mountValuesPhases(response) {
    const isZero = !response.legalRequestCount;
    response.legalRequestCount = !isZero ? String(response.legalRequestCount) : '-';
    response.initCalculateValue = !isZero
      ? parseFloat(response.initCalculateValue).toFixed(2)
      : '-';
    response.updateCalculateValue = !isZero
      ? parseFloat(response.updateCalculateValue).toFixed(2)
      : '-';
    response.totalriskCalculate = !isZero
      ? parseFloat(response.totalriskCalculate).toFixed(2)
      : '-';
  }

  public changeValueNewClaim($event, field, required = null) {
    field.value = $event;
    field.error = [];
    if (required !== null) field.required = required;
  }

  private dateTreatment(unixValue) {
    if (unixValue) return unixValue;
    // moment.unix(unixValue).format(moment.defaultFormat);
    else return null;
  }

  public filterPhases(val) {
    let value = false;
    if (val) {
      this.stepsRender = this.steps;
      value = true;
      this.transition = 'entrada';
      this.loadData();
    } else {
      this.transition = 'saida';
      setTimeout(() => {
        this.stepsRender = this.steps.filter((_, idx) => idx === 0);
        this.loadData();
      }, 600);
    }

    this.getFieldv['oldPhases'].value = value;
  }

  // Modais
  public openModalPhase(): void {
    const select = this.getFieldv['selectNewPhase'];
    select.labelValue = '';
    select.value = '';
    this.modalController.showModal(this.templateModal);
  }

  public closeModal(): void {
    // global
    this.modalController.closeModal();
  }

  public openEditModal($event, pedidos): void {
    this.pedidoEdit = [];
    this.pedidoEdit.push(pedidos);
    this.editPhase = this.steps.find((getStep) => {
      if (
        getStep?.step?.id === pedidos.stepId ||
        getStep.id === pedidos.stepId ||
        getStep.mainId === pedidos.stepId
      )
        return getStep;
    });
    this.modalController.showModal(this.editModal);
  }

  public openRegisterModal($event, phase): void {
    this.registerPhase = phase;
    this.modalController.showModal(this.registerModal);
  }

  public editItem($event, lane) {
    const pedidos = JSON.parse(JSON.stringify(lane));
    this.openEditModal($event, pedidos);
  }

  // Tables

  private mainData() {
    this.mainDataFields = fieldListPrimary;

    this.mainDataFields.primary.forEach((element, index) => {
      if (index === 0)
        this.colsMainClaim.push({
          name: 'content',
          type: 'action-delete',
          functionDelete: (element) => this.confirmDelete(element),
          col: 1,
        });

      const obj: any = {
        name: element.entityKey,
        label: element.label,
        type: 'data',
        orderDefault: index === 1 ? true : false,
        order: false,
        col: element.size,
        field: Object.assign({}, element),
      };
      obj.field.disabled = true;

      this.colsMainClaim.push(obj);
    });

    this.colsMainClaim.push(
      {
        label: 'Editar',
        type: 'data',
        cssHeader: 'text-center',
        templateRef: this.actionsEditRender,
        order: true,
        col: 1,
      },
      {
        label: 'Excluir',
        type: 'data',
        cssHeader: 'text-center',
        templateRef: this.actionsExcluirRender,
        order: true,
        col: 1,
      },
    );

    this.colsMainClaim.push({
      name: 'details',
      label: '',
      type: 'details-table',
      col: 1,
    });

    this.mainDataFields.secondary.forEach((element, index) => {
      const obj = {
        name: element.entityKey,
        label: element.label,
        type: 'data',
        orderDefault: index === 1 ? true : false,
        order: false,
        col: element.size,
        field: element,
      };

      this.colsSecMainClaim.push(obj);
    });
  }

  private async preparaTableByClaim() {
    return new Promise((resolve, reject) => {
      const fieldSelect = this.getFieldv['selectNewPhase'].auxEntity;
      if (!fieldSelect) return reject('erro: fieldSelect não localizado');

      const tableName = fieldSelect.tableName;
      const entityUrl = fieldSelect.entityUrl;
      const params: any = { tableName };

      this.dynamicFormService.getDinamicUrl(entityUrl, params).subscribe((resp: any) => {
        resp.forEach((fase) => {
          this.tableDataClaim[fase.id] = {
            config: {
              highlight: () => {
                return true;
              },
            },
            columns: this.colsMainClaim,
            details: this.colsSecMainClaim,
            body: [],
            loaded: false,
          };
        });
        resolve(this.tableDataClaim);
      });
    });
  }

  private defautlFeedbackServerError(error): boolean {
    this.setFeedback(
      this.claimLabelsDict['error-server-primary'],
      this.claimLabelsDict['error-server-secondary'],
      'emoji--expressionless',
      'danger',
    );
    return false;
  }

  private setFeedback(
    primary: string,
    secondary: string,
    emoji: string,
    type: 'danger' | 'warning' | 'success',
    autoclose = true,
  ): void {
    this.messageFeedObject.primary = primary;
    this.messageFeedObject.secondary = secondary;
    this.messageFeedObject.emoji = emoji;
    this.messageFeedObject.type = type;
    this.messageFeedObject.autoclose = autoclose;
    this.messageFeedObject.show = true;
  }

  public showTemplateMessage(data: any[]): void {
    if (!data) return;
    this.popupFeedController.autoclose = 4000;
    this.feedtext = data[0];
    this.emojis = data[1];
    this.popupFeedController.show(this.templateMessage);
  }
}
